import React from 'react';
import Container from '../../../containers/master/courses/showCourseContainer';

export default function () {
  return (
    <Container />
  );
}
